import './Hashtag.css'

const Hashtag = ({ children }) => {
  return (
    <span className="hashtag">
      {children}
    </span>
  )
}

export default Hashtag
